import { useTooltip } from "hooks/useTooltip";

export const Zombie = () => {
    const { tooltipRef } = useTooltip({ title: "Sylvia" });

    return (
        <div className="zombie align-self-center align-self-lg-start mb-6" ref={tooltipRef}>
            <div className="detail-1"></div>
            <div className="detail-2"></div>
            <div className="detail-3"></div>
            <div className="detail-4"></div>
            <div className="detail-5"></div>
            <div className="ear-left"></div>
            <div className="ear-right"></div>
            <div className="brain"></div>
            <div className="eye-left"></div>
            <div className="eye-right"></div>
            <div className="nose"></div>
            <div className="mouth">
                <div className="tooth-1"></div>
                <div className="tooth-2"></div>
                <div className="tooth-3"></div>
                <div className="slime"></div>
                <div className="slime-1"></div>
                <div className="slime-2"></div>
                <div className="slime-3"></div>
            </div>
        </div>
    );
};
